/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userPinUpdate

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userPinUpdate.UserPinUpdateApi
import features.userPinUpdate.models.UserProfileModel
import features.userPinUpdate.serializeUserPinUpdateState
import features.userPinUpdate.models.UpdatePinRequest

import kotlinx.serialization.decodeFromString

/**
 * Update a users' PIN [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserPinUpdateApi")
class UserPinUpdateApiJs {

    /**
     * Update a users' PIN
     */


    
    fun updatePin(overrideHeaders: String?,
serializedUpdatePinRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = UserPinUpdateApi().updatePin(
            overrideHeaders = decodedOverrideHeaders,
                updatePinRequest = Json.decodeFromString(
                    serializedUpdatePinRequest
                )
            ).toJsonResult<UserProfileModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeUserPinUpdateState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserPinUpdateApi().userPinUpdateState.serializeUserPinUpdateState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
